const LOG_PREFIX = "[OCM][Custom] "
const InstreamHB = require('../../services/instream_hb')

window.OCM.inread_slot = null

let customCode = (utils) => {
  return new Promise((resolve, reject) => {
    if (utils.getParameterByName('ma_vid') == '1') {
      utils.config.services.instream.active = true
      const is = new Instream(utils, utils.config)
      is.run()
    } else {
      utils.contentLoaded().then(() => {
        runOutstream(utils)
        injectPrestitial()
      })

      // after ocmPassback()
      window.oopb = () => {
        var rand = Math.random()
        if (rand <= 0.50) {
          ppnPassback(document.querySelector('.teads-adCall'), 402016, 1366512);
        } else {
          utils.loadScript('https://thetamarketplace.com/serve/newpostinread', 'text/javascript', 1)
        }
      }

      var originalOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function() {
        // Infinite scrolling teads
        this.addEventListener("loadend", reRunOutstream);

        originalOpen.apply(this, arguments);
      }
    }
    resolve(true)
  });
};

let runOutstream = (utils) => {
  (function(w, d) {
    try {
      d = w.top.document || d; w = w.top.document ? w.top : w;
    } catch (e) {}
    var ttag = function() {
      // Check v1 outstream service for excluded urls and append them in the array below
      const exclude_urls = [
        {'url': 'cinema/602680657192fc56126a296f/poliorkia-stin-odo-liperti-to-vraveymeno-syghrono-goyestern-kanei-online-pagkosmia-premiera-kai-den-prepei-na-to-haseis'},
        {'url': 'cinema/60179fe878755edd234a0b4e/i-mpalanta-tis-trypias-kardias-epistrefei-gia-liges-provoles'},
        {'url': 'ellada/5ee88deacbb45090528a746e/mega-proionta-atomikis-ygieinis-a-e-axeperasti-proiontiki-asfaleia-me-elliniki-ypografi'},
        {'url': 'oikonomia/5eb10acea9de309d544effc5/psifos-empistosynis-ton-katanaloton-stis-ilektronikes-agores-trofimon'},
      ]

      for (let x = 0; x < exclude_urls.length; x++) {
        if (w.location.href.includes(exclude_urls[x].url)) {
          return
        }
      }

      // You need to find these 2 numbers (pm @Katerina, @peter, @Theo)
      w.teads.page(125632).placement(136732, {
        slider: {
          allow_corner_position: false, 
          allow_top_position: false
        }, 
        "css":"margin: 0px auto 37px; max-width: 650px;", // The margin should reflect the styles of the articles paragraphs
        "format":"inread",
        "slot":{
          //           "insertInside": true, // If there is a dedicated div by the publisher, then we use insertInside, else available options are insertAfter, insertBefore
          "selector":".article-main p", // The target to inject the teads video tag
          "minimum":2 // If the target is a multiple node result (e.g. .article > p), then supply the minimum (starts counting from 1, not 0)
        }
      }).passback(() => {
        // Runs after instream service and only if no video ad came back
        window.OCM.oipb = () => {
          ocmPassback(utils, document.querySelectorAll('.article-main p')[1])
        }

        // Enables the instream service, instantiates the class and runs it (you should have the service configured in its tab, but inactive)
        utils.config.services.instream_hb.active = true
        const is = new InstreamHB(utils, utils.config)
        is.run()
      }).serve();
    };
    if (w.teads && w.teads.page) { ttag(); }
    else if (!w.teadsscript) {
      var s = document.createElement('script');
      s.src = 'https://s8t.teads.tv/media/format/v3/teads-format.min.js';
      s.async = true; s.onload = ttag; w.teadsscript = d.getElementsByTagName('head')[0].appendChild(s);
    } else {
      w.teadsscript.addEventListener('load', ttag);
    }
  })(window, document); 
}

let reRunOutstream = function() {
  if (this.responseURL.includes('api/posts/getPost')) {
    console.log('reRunOutstream')
    if (window.OCM.inread_slot) {
      googletag.cmd.push(function() {
        googletag.destroySlots([window.OCM.inread_slot]);
      });
    }

    setTimeout(runOutstream, 1000);
  }
}

let ocmPassback = (utils, selector) => {
  console.log('ocmPassback')
  if (!selector) {
    return
  }

  selector.insertAdjacentHTML('afterend', `<div id="ocm-outstream" style="margin-bottom:1.55em"></div>`)

  window.googletag = window.googletag || {cmd: []};
  googletag.cmd.push(function() {
    //     let inread = googletag.sizeMapping()
    //     .addSize([0,0], [[1,1],[300, 250],[300,600]])
    //     .addSize([360,0], [[1,1],[300,600],[336,280],[300, 250]])
    //     .addSize([768,0], [[1,1],[336,280],[300,250]])
    //     .build()

    // Change the ad unit path
    window.OCM.inread_slot = googletag.defineSlot('/15637987/newpost.gr/inread_pb', [1,1], 'ocm-outstream').addService(googletag.pubads());
  });
}

let injectPrestitial = () => {
  window.googletag = window.googletag || {cmd: []};

  googletag.cmd.push(function() {
    var top_el = document.querySelectorAll('body *')[0];
    var prediv = document.createElement('div');
    prediv.id = 'div-gpt-ad-1505919070474-3';
    var prescript = document.createElement('script');
    prescript.text = 'googletag.cmd.push(function() { googletag.display("div-gpt-ad-1505919070474-3") });';
    top_el.parentNode.insertBefore(prediv, top_el);
    prediv.append(prescript);	
  });
}

function ppnPassback(selector, siteId, pageId) {
  console.log('ppnPassback')
  if (selector === undefined) {
    return;
  }
  var scripts = document.getElementsByTagName('script')[0];
  var s = document.createElement('script');
  s.async = true;
  s.src = "https://ced.sascdn.com/tag/3433/smart.js";
  scripts.parentNode.insertBefore(s, scripts);
  var ppn_div = document.createElement('div');
  ppn_div.id = 'sas_80268';
  var ppn_script = document.createElement('script');
  ppn_script.text = 'var sas = sas || {};\n' +
    '    sas.cmd = sas.cmd || [];\n' +
    '    sas.cmd.push(\n' +
    '        function () {\n' +
    '            sas.call(\n' +
    '                { siteId: ' + siteId + ', pageId: ' + pageId + ', formatId: 80268, tagId: "sas_80268" },\n' +
    '                { networkId: 3433, domain: "//www8.smartadserver.com" }\n' +
    '            );\n' +
    '        }\n' +
    '    );';
  selector.parentNode.insertBefore(ppn_div, selector.nextSibling);
  selector.parentNode.insertBefore(ppn_script, selector.nextSibling);
}

module.exports = customCode;